export enum CaregiverTaskCompletion {
  DONE = 'done',
  NOT_DONE = 'not-done',
  PLANNED = 'planned',
  MISSED = 'missed',
}
